import {
    FieldInCard,
} from 'app/types/form.types'
import {
    RichTableColumns,
} from '../../types/richtable.types'
import FormErrorList from '../../common/DomainObject/ComponentMapper/FormErrorList'
import {
    FailedUpload,
    FeedbackFormData, UpdateFormData,
} from './SimpleBulkUpload.types'

export const selectedRecordsField: FieldInCard<keyof UpdateFormData> = {
    name: 'selectedRecords',
    componentName: 'InputSingleline',
    labelKey: 'BulkUpload.selectedRecords',
    disabled: true,
}

export const updatedRecordsField: FieldInCard<keyof FeedbackFormData> = {
    name: 'updatedRecords',
    componentName: 'InputSingleline',
    labelKey: 'BulkUpload.updatedRecords',
    disabled: true,
}

export const getErrorColumn = (
    name: string,
    l: (key: string) => string,
): RichTableColumns<keyof FailedUpload> => {
    return {
        id: 'errors',
        headerProps: {
            children: l('BulkUpload.error'),
        },
        mapCellProps: ({
            errors,
        }) => {
            return {
                value: errors,
                labelPrefix: name,
            }
        },
        Cell: FormErrorList,
    }
}

export const WAIT_BETWEEN_REQUESTS_IN_SERIES = 100
